import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";

const links = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/about", label: "About", testid: "nav-link-about" },
  { to: "/experience", label: "Experience", testid: "nav-link-experience" },
  { to: "/projects", label: "Projects", testid: "nav-link-projects" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[var(--surface-2)] border-b border-[var(--border-soft)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2 font-display text-2xl font-semibold">
          <span className="inline-block w-2 h-2 rounded-full bg-[var(--peach)]" />
          Nikita Singh
        </Link>

        <nav className="hidden md:flex items-center gap-1 p-1 rounded-full bg-[var(--surface-2)] backdrop-blur border border-[var(--border-soft)]">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testid}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-semibold rounded-full transition-all ${
                  isActive ? "bg-[var(--text)] text-[var(--bg)]" : "text-[var(--text-muted)] hover:text-[var(--text)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <ThemeToggle />
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full border border-[var(--border-soft)] bg-[var(--surface)]"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-[var(--border-soft)] bg-[var(--surface)]">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`m-${l.testid}`}
                className={({ isActive }) =>
                  `px-4 py-3 font-semibold rounded-2xl transition-all ${
                    isActive ? "bg-[var(--peach-soft)] text-[var(--text)]" : "text-[var(--text-muted)]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
